import { useMemo } from 'react';

import { ILanguageItem, TLanguageValue } from 'interfaces/languageItem';

export const useLanguageSettingsData = () => {
  const languageContent: ILanguageItem[] = useMemo(
    () => [
      { title: 'DE', value: 'de' },
      { title: 'UA', value: 'uk' },
      { title: 'EN', value: 'en' },
      { title: 'ES', value: 'es' },
    ],
    [],
  );

  const getTitleFromValue = (value: TLanguageValue) => {
    switch (value) {
      case 'de':
        return 'DE';
      case 'uk':
        return 'UA';
      case 'es':
        return 'ES';
      default:
        return 'EN';
    }
  };

  return {
    languageContent,
    getTitleFromValue,
  };
};
